/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $League = {
    properties: {
        tableRating: {
            type: 'LeagueRatingEnum',
            isRequired: true,
        },
        main: {
            type: 'boolean',
            isRequired: true,
        },
        category: {
            type: 'LeagueCategoryEnum',
            isRequired: true,
        },
        officialName: {
            type: 'string',
            isRequired: true,
        },
        internalName: {
            type: 'string',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
        subCategory: {
            type: 'SubCategory',
            isRequired: true,
        },
        year: {
            type: 'number',
            isRequired: true,
        },
        hasPlayerStatistics: {
            type: 'boolean',
            isRequired: true,
        },
        hasTeamStatistics: {
            type: 'boolean',
            isRequired: true,
        },
        hasPlayerRating: {
            type: 'boolean',
            isRequired: true,
        },
        hasManOfTheMatch: {
            type: 'boolean',
            isRequired: true,
        },
        hasLineup: {
            type: 'boolean',
            isRequired: true,
        },
        hasFeed: {
            type: 'boolean',
            isRequired: true,
        },
        hasScorers: {
            type: 'boolean',
            isRequired: true,
        },
        hasSquad: {
            type: 'boolean',
            isRequired: true,
        },
        hasBetting: {
            type: 'boolean',
            isRequired: true,
        },
        matchSectionAmount: {
            type: 'number',
            isRequired: true,
        },
        matchSectionDurationMinutes: {
            type: 'number',
            isRequired: true,
        },
        matchSectionPauseDurationMinutes: {
            type: 'number',
            isRequired: true,
        },
        active: {
            type: 'boolean',
            isRequired: true,
        },
        currentMatchDay: {
            type: 'number',
            isRequired: true,
        },
        sports: {
            type: 'SportEnum',
            isRequired: true,
        },
        matchDays: {
            type: 'number',
            isRequired: true,
        },
        amountMatchDaysHalfSeason: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        division: {
            type: 'any-of',
            contains: [{
                type: 'Division',
            }, {
                type: 'null',
            }],
        },
        lndLeagueShort: {
            type: 'string',
            isRequired: true,
        },
        district: {
            type: 'string',
            isRequired: true,
        },
        promotion: {
            type: 'number',
            isRequired: true,
        },
        promotionContender: {
            type: 'number',
            isRequired: true,
        },
        relegationBattler: {
            type: 'number',
            isRequired: true,
        },
        relegation: {
            type: 'number',
            isRequired: true,
        },
        areasOfInterest: {
            type: 'array',
            contains: {
                type: 'AreaOfInterest',
            },
            isRequired: true,
        },
        externalId: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        amountPlayers: {
            type: 'number',
            isRequired: true,
        },
        note: {
            type: 'string',
        },
    },
} as const;
